import React from 'react';

import { Modal, Spinner } from 'components';

import { ReceiptUploaderError } from './ReceiptUploaderError';

type Props = {
  open: boolean;
  failed: boolean;
  onClose: () => void;
};

// Stands in for the Uppy dashboard while it loads or after it failed to, so an opened dialog is never
// an empty screen.
export const ReceiptUploaderPlaceholder: React.FC<Props> = ({
  open,
  failed,
  onClose,
}) => (
  <Modal open={open} onClose={onClose}>
    <div className="tw-flex tw-justify-center tw-pb-2">
      {failed ? <ReceiptUploaderError /> : <Spinner />}
    </div>
  </Modal>
);
